
/* Swipers */

// intro
const intro4Swiper = new Swiper(".intro4Swiper", {
    navigation: {
        nextEl: ".intro__swiper-button-next",
        prevEl: ".intro__swiper-button-prev",
    },
    pagination: {
        el: ".intro__swiper-pagination",
        type: "fraction",
    },
    scrollbar: {
        el: ".intro__swiper-scrollbar",
    },
});

// reviews
const reviewsSwiper = new Swiper(".reviewsSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".reviews__swiper-button-next",
        prevEl: ".reviews__swiper-button-prev",
    },
    breakpoints: {
        920: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    },
});

// doctors
const doctorsSwiper = new Swiper(".doctorsSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".doctors__swiper-button-next",
        prevEl: ".doctors__swiper-button-prev",
    },
    scrollbar: {
        el: ".doctors__swiper-scrollbar",
    },
    breakpoints: {
        1020: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    },
});

// articles
const articlesSwiper = new Swiper(".articlesSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".articles__swiper-button-next",
        prevEl: ".articles__swiper-button-prev",
    },
    breakpoints: {
        1100: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        760: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    },
});

// licenses
const licensesSwiper = new Swiper(".licensesSwiper", {
    direction: 'horizontal',
    slidesPerView: 1.4,
    spaceBetween: -80,
    loop: true,
    speed: 600,
    navigation: {
        nextEl: ".licenses__swiper-button-next",
        prevEl: ".licenses__swiper-button-prev",
    },
    scrollbar: {
        el: ".licenses__swiper-scrollbar",
        clickable: true,
    },
    breakpoints: {
        450: {
            slidesPerView: 2.5,
        },
    },
});

// stocks
const stocksSwiper = new Swiper(".stocksSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".stocks__swiper-button-next",
        prevEl: ".stocks__swiper-button-prev",
    },
    pagination: {
        el: ".stocks__swiper-pagination",
        type: "fraction",
    },
    scrollbar: {
        el: ".stocks__swiper-scrollbar",
    },

    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            origin: "left center",
            translate: ["-5%", 0, -200],
            rotate: [0, 100, 0],
        },
        next: {
            origin: "right center",
            translate: ["5%", 0, -200],
            rotate: [0, -100, 0],
        },
    },
});

// doctors diplomas
const doctorDiplomasSwiper = new Swiper(".doctorDiplomasSwiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
        688: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        960: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    },
    navigation: {
        nextEl: ".diplomas__swiper-button-next",
        prevEl: ".diplomas__swiper-button-prev",
    },
});








// gallery
const gallery1Swiper = new Swiper(".gallery1Swiper", {
    slidesPerView: 1,
    grid: {
        rows: 1,
    },
    spaceBetween: 10,
    navigation: {
        nextEl: ".gallery__swiper-button-next",
        prevEl: ".gallery__swiper-button-prev",
    },
    breakpoints: {
        1000: {
            slidesPerView: 4,
            spaceBetween: 20,
            grid: {
                rows: 2,
            },
        },
        800: {
            slidesPerView: 3,
            grid: {
                rows: 2,
            },
        },
        660: {
            slidesPerView: 2,
            spaceBetween: 10,
            grid: {
                rows: 1,
            },
        },
    },
});

const gallery4Swiper = new Swiper(".gallery4Swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".gallery__swiper-button-next",
        prevEl: ".gallery__swiper-button-prev",
    },
    scrollbar: {
        el: ".gallery__swiper-scrollbar",
    },
    speed: 600,
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            origin: "left center",
            translate: ["-5%", 0, -200],
            rotate: [0, 100, 0],
        },
        next: {
            origin: "right center",
            translate: ["5%", 0, -200],
            rotate: [0, -100, 0],
        },
    },
});

const gallery5Swiper = new Swiper(".gallery5Swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".gallery__swiper-button-next",
        prevEl: ".gallery__swiper-button-prev",
    },
    pagination: {
        el: ".gallery__swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        1100: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        700: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    },
});

// tariff
const tariffCardSwiper = new Swiper(".tariffCardSwiper", {
    navigation: {
        nextEl: ".tariff-card__swiper-button-next",
        prevEl: ".tariff-card__swiper-button-prev",
    },
    pagination: {
        el: ".tariff-card__swiper-pagination",
    },
});

const tariffEconomSwiper = new Swiper(".tariffEconomSwiper", {
    navigation: {
        nextEl: ".tariff-econom__swiper-button-next",
        prevEl: ".tariff-econom__swiper-button-prev",
    },
    pagination: {
        el: ".tariff-econom__swiper-pagination",
    },
});

const tariffComfortSwiper = new Swiper(".tariffComfortSwiper", {
    navigation: {
        nextEl: ".tariff-comfort__swiper-button-next",
        prevEl: ".tariff-comfort__swiper-button-prev",
    },
    pagination: {
        el: ".tariff-comfort__swiper-pagination",
    },
});

const tariffPremiumSwiper = new Swiper(".tariffPremiumSwiper", {
    navigation: {
        nextEl: ".tariff-premium__swiper-button-next",
        prevEl: ".tariff-premium__swiper-button-prev",
    },
    pagination: {
        el: ".tariff-premium__swiper-pagination",
    },
});

const tariff1Swiper = new Swiper(".tariff1Swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".tariff__swiper-button-next",
        prevEl: ".tariff__swiper-button-prev",
    },
    pagination: {
        el: ".tariff__swiper-pagination",
        type: "fraction",
    },
});

const tariff2Swiper = new Swiper(".tariff2Swiper", {
    slidesPerView: 1.02,
    spaceBetween: 20,
    navigation: {
        nextEl: ".tariff__swiper-button-next",
        prevEl: ".tariff__swiper-button-prev",
    },
    pagination: {
        el: ".tariff__swiper-pagination",
    },
    breakpoints: {
        1160: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        700: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    },
});
if (window.innerWidth < 1160) {
    tariff2Swiper.enable()
} else {
    tariff2Swiper.disable()
}

const tariff3Swiper = new Swiper(".tariff3Swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".tariff__swiper-button-next",
        prevEl: ".tariff__swiper-button-prev",
    },
    scrollbar: {
        el: ".tariff__swiper-scrollbar",
    },
    breakpoints: {
        1160: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        700: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
    },
});
if (window.innerWidth < 1160) {
    tariff3Swiper.enable()
} else {
    tariff3Swiper.disable()
}

// licenses-page
const licensesPage1Swiper = new Swiper(".licenses-page1Swiper", {
    slidesPerView: 1.2,
    spaceBetween: 13,
    loop: true, 
    breakpoints: {
        1100: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        800: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 13,
        },
    },
    navigation: {
        nextEl: ".licenses-page__swiper-button-next-1",
        prevEl: ".licenses-page__swiper-button-prev-1",
    },
    scrollbar: {
        el: ".licenses-page__swiper-scrollbar-1",
    },
});

const licensesPage2Swiper = new Swiper(".licenses-page2Swiper", {
    slidesPerView: 1.2,
    spaceBetween: 13,
    loop: true, 
    breakpoints: {
        1100: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        800: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 13,
        },
    },
    navigation: {
        nextEl: ".licenses-page__swiper-button-next-2",
        prevEl: ".licenses-page__swiper-button-prev-2",
    },
    scrollbar: {
        el: ".licenses-page__swiper-scrollbar-2",
    },
});





/* End swipers */